import { cn } from '@/lib/utils';

export interface DashboardPanelProps {
  title: string;
  action?: React.ReactNode;
  children: React.ReactNode;
  fullWidth?: boolean;
  className?: string;
}

export function DashboardPanel({
  title,
  action,
  children,
  fullWidth,
  className,
}: DashboardPanelProps) {
  return (
    <div
      className={cn(
        'rounded-lg border border-border bg-bg-surface overflow-hidden',
        fullWidth && 'col-span-full',
        className
      )}
    >
      <div className="flex items-center justify-between px-4 py-3 border-b border-border">
        <h3 className="text-base font-medium text-fg">{title}</h3>
        {action}
      </div>
      <div className="p-4">{children}</div>
    </div>
  );
}
